export default {
  SET_TOKEN_MUTATION: "setToken",
  SET_SYSTITLE: "setSystitle",
  SET_USERNAME_MUTATION: "setUserName",
  SET_PWD_MUTATION: "setPwd",
  PUSH_REQ_TOKEN: "pushReqToken",
  CLEAR_REQ_TOKEN: "clearReqToken",
};
